import { z } from 'zod'

import { emptySelectOptionZod } from 'components/Select'
import { commonSchema } from 'features/globalSetup/forms/Prebid/Bidders/schemas/commonSchema'
import { WorkspaceBidderSlice } from 'features/globalSetup/pages/Prebid/Bidders/EditBidderPage/hooks/useGetWorkspaceBidder'
import { BidderSlice } from '../types'

export type EditSchema = z.infer<typeof commonSchema>

export const editSchemaDefault = (workspaceBidder: WorkspaceBidderSlice): EditSchema => {
  const {
    accountType,
    bidCpmAdjustment,
    bidderCode,
    bidderSid,
    consentMode,
    priority,
    status,
    supplyChain,
  } = workspaceBidder

  return {
    accountType,
    bidCpmAdjustment,
    bidderCode,
    bidderId: emptySelectOptionZod<BidderSlice>(),
    bidderSid: bidderSid || '',
    consentMode,
    priority,
    status,
    supplyChain: supplyChain?.id ?? '',
  }
}
